import { TravelSearchTogglesEffects } from './travel-search-toggles.effects';
import { TravelBookingProgressBarEffects } from './travel-booking-progress-bar.effects';
import { TravelBookingEffects } from './travel-booking.effects';
import { TravelCarHireSubBookingEffects } from './travel-car-hire-sub-booking.effects';
import { TravelHotelSubBookingEffects } from './travel-hotel-sub-booking.effects';
import { TravelFlightSubBookingEffects } from './travel-flight-sub-booking.effects';

export const effects: any[] = [
  TravelBookingProgressBarEffects,
  TravelSearchTogglesEffects,
  TravelBookingEffects,
  TravelCarHireSubBookingEffects,
  TravelHotelSubBookingEffects,
  TravelFlightSubBookingEffects,
];

export * from './travel-booking-progress-bar.effects';
export * from './travel-search-toggles.effects';
export * from './travel-booking.effects';
export * from './travel-car-hire-sub-booking.effects';
export * from './travel-hotel-sub-booking.effects';
export * from './travel-flight-sub-booking.effects';
